import { User } from 'iconsax-react'
import React, { useState } from 'react'

import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'

interface ProfilePicturePreviewProps {
  imageUrl?: string
  size?: 'small' | 'medium' | 'large'
}

const sizeClasses = {
  small: 'w-16 h-16',
  medium: 'w-24 h-24',
  large: 'w-32 h-32',
}

const iconSizes = {
  small: 54,
  medium: 76,
  large: 108,
}

export const ProfilePicturePreview = ({
  imageUrl,
  size = 'large',
}: ProfilePicturePreviewProps) => {
  const [imageError, setImageError] = useState(false)

  const showPlaceholder = !imageUrl || imageError

  return (
    <div
      className={`${sizeClasses[size]} rounded-full overflow-hidden border-2 border-neutralColor30 bg-baseColor flex items-end justify-center`}
    >
      {showPlaceholder ? (
        <User
          size={iconSizes[size]}
          color={SocialMirrorPalette.neutralColor30}
          variant="Bold"
          className="mb-[-6px]"
        />
      ) : (
        <img
          src={imageUrl}
          alt="Profile preview"
          className="w-full h-full object-cover"
          onError={() => setImageError(true)}
        />
      )}
    </div>
  )
}
